import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from "prop-types";

const findIndex = (values, val) => {
  if (val !== undefined){
    for (let i = 0; i < values.length; i++) {
      if (values[i].value === val) return values[i].name
    }
  }
  return undefined
}

class panelVehicles extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].dataresume
    const langNames = languages[langUrl].dataresume.names
    const { yesno,  length, displacement } = languages[langUrl]

    const {index, name} = this.props
    const key = (this.props.name + this.props.index).toLowerCase()
    const values = (this.props.data[key] !== undefined)?this.props.data[key]: {}

    return (
      <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12 resume-panel'>
        <div className='cuadre-height cuadre-principal'>
          <div className='cuadre-title'>{langPlace.vehicle}</div>
          <div className='cuadre-subtitle'>{`${langPlace[name]} #${index}`}</div>
        </div>
        <div className='col-md-6 no-padding'>
          <div className='cuadre-height cuadre-transparent'>
            <div className='cuadre-title'>{langNames.brand}</div>
            <div className='cuadre-subtitle'>{values.brand}</div>
          </div>
        </div>
        <div className='col-md-6 no-padding'>
          <div className='cuadre-height cuadre-transparent'>
            <div className='cuadre-title'>{langNames.model}</div>
            <div className='cuadre-subtitle'>{values.model}</div>
          </div>
        </div>
        <div className='col-md-6 no-padding'>
          <div className='cuadre-height cuadre-transparent'>
            <div className='cuadre-title'>{langNames.licensePlate}</div>
            <div className='cuadre-subtitle'>{values.licensePlate}</div>
          </div>
        </div>
        <div className='col-md-6 col-sm-12 no-padding'>
          {(name === 'car')?
            <div className='cuadre-height cuadre-transparent'>
              <div className='cuadre-title'>{langNames.exported}</div>
              <div className='cuadre-subtitle'>{findIndex(yesno, values.exported)}</div>
            </div>
          :(name === 'motorcycles')?
            <div className='cuadre-height cuadre-transparent'>
              <div className='cuadre-title'>{langNames.displacement}</div>
              <div className='cuadre-subtitle'>{findIndex(displacement, values.displacement)}</div>
            </div>
          :
            <div className='cuadre-height cuadre-transparent'>
              <div className='cuadre-title'>{langNames.length}</div>
              <div className='cuadre-subtitle'>{findIndex(length, values.length)}</div>
            </div>
          }
        </div>

      </div>
    )
  }
}

export default connect(
  (state) => ({settings: state.settings, data: state.data})
)(panelVehicles)



// WEBPACK FOOTER //
// ./src/shared/routes/routeResume/components/panelVehicles.js